import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { capitalize } from '../../../../../shared/StringExtensions';
import OrderCollectionList, { IOrderCollection } from './OrderCollectionList';

type OrderCollectionSectionProps = {
    title: string;
    orderCollections: IOrderCollection[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: number | null;
};

function OrderCollectionSection({
    title,
    orderCollections,
    user,
    navigateTo,
    newOrderId
}: OrderCollectionSectionProps) {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    function handleCollapseExpand() {
        setIsOpen((state) => !state);
    }

    return (
        <div className="orderCollectionSection__container">
            <button
                className="orderCollectionSection__headingToggleButton"
                onClick={handleCollapseExpand}
            >
                <div className="orderCollectionSection__headerContainer">
                    <h2 className="orderCollectionSection__heading">{capitalize(title)}</h2>
                    {isOpen ? (
                        <i className="orderCollectionSection__expandCollapseIcon material-icons">
                            expand_more
                        </i>
                    ) : (
                        <i className="orderCollectionSection__expandCollapseIcon material-icons">
                            expand_less
                        </i>
                    )}
                </div>
            </button>
            <Collapse in={isOpen}>
                <div>
                    <OrderCollectionList
                        items={orderCollections}
                        user={user}
                        navigateTo={navigateTo}
                        newOrderId={newOrderId}
                    />
                </div>
            </Collapse>
        </div>
    );
}

export default OrderCollectionSection;
